<template>
  <div id="content" v-if="loaded">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <p class="paging">
        <a @click="$router.go(-1)" class="btn btn_back" v-translate>Seznam</a>
      </p>
      <h1 v-translate>Nový import registrovaných MAC adres</h1>
    </div>

    <div class="responsiveTabs">
      <div class="tabs_content">
        <section>
          <div class="left">
            <h2 v-translate>Základní údaje</h2>
          </div>
          <div class="right">
            <div class="field_left">
              <textarea-input id="macaddressdescription"
                          :required="true"
                          v-model="entity.description"
                          :disabled="!isEditable"
                          ref="macaddressdescriptionref"
              >
                <translate class="translate">Popis</translate>
              </textarea-input>
              <radio-input
                  id="macFromInput"
                  name="inputType"
                  p-class="field"
                  v-model="inputType"
                  :disabled="!isEditable || !canChangeInputType"
                  :val="inputType"
              >
                <translate class="translate">Textový seznam MAC adres</translate>
              </radio-input>
              <radio-input
                  id="macFromFile"
                  name="inputType"
                  p-class="field"
                  v-model="inputType"
                  :disabled="!isEditable || !canChangeInputType"
                  :val="inputType"
              >
                <translate class="translate">Vložit CSV seznam MAC adres</translate>
              </radio-input>
              <textarea-input
                  v-show="inputType==='macFromInput'"
                  id="note"
                  rows=6
                  v-model="entity.mac_list"
                  :disabled="!isEditable"
                  :help-text="$gettext('1 MAC adresa na řádek')"
              >
                <translate class="translate">Seznam MAC adres</translate>
              </textarea-input>
              <file-input
                  v-show="inputType==='macFromFile'"
                  id="csvfile"
                  @change="onFileChange"
                  ref="csvfileref"
                  :disabled="!isEditable"
                  :help-text="'Jednotlivé MAC adresy na samostatných řádcích'"
                  :button-text="'Nahrát CSV soubor'"
                  :accept="'.csv'"
              >
                <translate class="translate">Upload CSV souboru</translate>
              </file-input>
            </div>
          </div>
        </section>
        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
            </router-link>
            <input v-if="isEditable"
                   type="submit"
                   :value="'Uložit' | translate"
                   :class="['btn']"
                   @click.prevent.stop="createEntity()">
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions";

export default {
  name: "registeredMacAddressBatchNew",
  mixins: [detailActions],
  props:{
    mac_addresses: Array,
  },
  data() {
    return {
      moduleName: 'registeredMacAddressBatches',
      detailName: 'registeredMacAddressBatchDetail',
      inputType: 'macFromInput',
      canChangeInputType: true,
      loaded: false,
      file: null,
      entity: {
        input_type: 'macFromInput'
      }
    };
  },
  created(RegisteredMacAddressBatchService) {
    this.entityService = RegisteredMacAddressBatchService;
    if(this.mac_addresses){
      this.setLoadingMessage()
      this.canChangeInputType = false;
      this.entityService.getUnregisteredMacAddressByIds({mac_ids: this.mac_addresses})
          .then((data)=>{
            this.entity.mac_list = data.mac_addresses.join("\r\n");
            this.emptyMessage();
            this.loaded = true;
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    }else{
      this.loaded=true;
    }
  },
  computed: {
    isEditable(){
      return this.$_createActionAllowed;
    }
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0]
    },
    createEntity(redirect = false) {
      let formData = new FormData();
      Object.keys(this.entity).forEach((key) =>{
        formData.append(key, this.entity[key]);
      });
      if(this.file) {
        formData.append('csv', this.file);
      }
      this.entityService.createEntity(formData)
          .then(data => {
              this.redirect(this.detailName, {id: data.id})
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    },
  },
  watch: {
    inputType(newValue) {
      this.$refs.csvfileref.resetFile();
      this.file = null;
      this.entity.mac_list = null;
      this.entity.input_type = newValue;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressBatchNew.vue